/**
 * Язык, на котором форматируются даты и деньги. Приложение покупателя
 * переключает его вместе с языком интерфейса; админка остаётся на русском.
 * Одна переменная на страницу: язык в приложении один, а передавать его в
 * каждый вызов `formatMoney` — десятки мест, где его легко забыть.
 */
export type DisplayLanguage = 'ru' | 'uz'

const LOCALES: Record<DisplayLanguage, string> = { ru: 'ru-RU', uz: 'uz-Latn-UZ' }
const CURRENCY: Record<DisplayLanguage, string> = { ru: 'сум', uz: 'so‘m' }

let current: DisplayLanguage = 'ru'

export function setDisplayLanguage(language: DisplayLanguage): void {
  current = language
}

export function displayLanguage(): DisplayLanguage {
  return current
}

/** «ru-RU» или «uz-Latn-UZ» — для toLocale*String. */
export function displayLocale(): string {
  return LOCALES[current]
}

/** «сум» или «so‘m». */
export function currencySuffix(): string {
  return CURRENCY[current]
}
